import * as a from "react";
import { createContext as v, useContext as k } from "react";
import { j as l } from "./radix-common-Dx8bZddK.js";
import { u as m } from "./radix-dialog-hzmYIvwL.js";
import { u as C } from "./embla-BE464U1q.js";
const c = /* @__PURE__ */ v("dark");
function P({
  children: e
}) {
  return /* @__PURE__ */ l.jsx(c.Provider, {
    value: "light",
    children: e
  });
}
function j({
  children: e
}) {
  return /* @__PURE__ */ l.jsx(c.Provider, {
    value: "dark",
    children: e
  });
}
function b({
  children: e,
  theme: n
}) {
  const t = k(c);
  return /* @__PURE__ */ l.jsx(c.Provider, {
    value: (n ?? t) === "dark" ? "light" : "dark",
    children: e
  });
}
function E({
  prop: e,
  defaultProp: n,
  onChange: t = () => {
  }
}) {
  const [r, o] = S({
    defaultProp: n,
    onChange: t
  }), s = e !== void 0, d = s ? e : r, i = m(t), h = a.useCallback((u) => {
    if (s) {
      const f = typeof u == "function" ? u(e) : u;
      f !== e && i(f);
    } else
      o(u);
  }, [s, e, o, i]);
  return [d, h];
}
function S({
  defaultProp: e,
  onChange: n
}) {
  const t = a.useState(e), [r] = t, o = a.useRef(r), s = m(n);
  return a.useEffect(() => {
    o.current !== r && (s(r), o.current = r);
  }, [r, o, s]), t;
}
function y(e, n) {
  return C({
    slidesToScroll: 1,
    skipSnaps: !0,
    containScroll: "keepSnaps",
    align: (t, r, o) => o > 0 ? e.prevSlidePeekOffset ?? 40 : 0,
    ...e
  }, n);
}
function D(e) {
  return (n) => {
    e.forEach((t) => {
      typeof t == "function" ? t(n) : t != null && (t.current = n);
    });
  };
}
export {
  j as D,
  P as L,
  b as R,
  c as T,
  y as a,
  D as m,
  E as u
};
//# sourceMappingURL=mergeRefs-CBC__vyO.js.map
